import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={102} height={81} viewBox="0 0 102 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M69.966.75c9.175 0 17.033 3.3 22.582 9.981 5.534 6.664 8.702 16.606 8.702 29.769 0 13.214-3.168 23.156-8.703 29.808-5.55 6.668-13.407 9.942-22.581 9.942-9.229 0-17.087-3.328-22.622-10.022-5.521-6.677-8.662-16.618-8.662-29.728 0-13.161 3.141-23.103 8.663-29.768C52.88 4.05 60.739.75 69.965.75zm-36.04 1.248v77.004H14.668V25.939l-12.815 6.8-1.102.584V14.252l.404-.21 23.057-11.96.162-.084h9.554zm36.04 15.956c-2.915 0-5.793 1.25-7.978 4.636-2.212 3.428-3.735 9.085-3.735 17.91 0 8.826 1.524 14.456 3.734 17.856 2.182 3.357 5.059 4.586 7.979 4.586 2.974 0 5.849-1.231 8.016-4.585 2.198-3.4 3.697-9.03 3.697-17.857 0-8.828-1.5-14.485-3.698-17.912-2.17-3.382-5.046-4.634-8.015-4.634z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
